import ApiService from '@/shared/services/api.service';

export class ApplicationTypeService {
    static list(params) {
        return new Promise((resolve, reject) => {
            ApiService.query('/application-types', params)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static create(data) {
        return new Promise((resolve, reject) => {
            ApiService.post( '/application-types', { ...data } )
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static update(id, data) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/application-types/${id}`, { ...data })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static async remove(id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/application-types/${id}`)
                .then(() => resolve())
                .catch((error) => {
                    reject(error);
                });
        });
    }

    static find(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/application-types/${id}`)
                .then((response) => resolve(response))
                .catch((error) => reject(error));
        });
    }

    static async listAutocomplete() {
        const response = await ApiService.get('/application-types');
        return response?.data?.data || [];
    }
}
